import { Controller } from "react-hook-form";
import { TextField, InputLabel, Grid, Box, Paper } from "@material-ui/core";
import { Message } from "~/Components/Message";
import { forgotPasswordDescription } from "~/constants";
import "./forgotPasswordStyle.scss";

export const ForgotPassword = ({ control, hideMessage, message }) => {
  return (
    <div className="card-wrapper">
      <Paper variant="outlined">
        <Box
          component="p"
          textAlign="center"
          className="card-wrapper-info sub-theme-color "
        >
          {forgotPasswordDescription}
        </Box>
        <form>
          <Grid container justifyContent="center">
            <Grid container item xs={12} className="input-wrapper">
              <InputLabel htmlFor="emailReset" className="label">
                Email
              </InputLabel>
              <Controller
                control={control}
                name="emailReset"
                defaultValue=""
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <>
                    <TextField
                      id="emailReset"
                      className="text-field"
                      onFocus={hideMessage}
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                      variant="outlined"
                      error={Boolean(error)}
                    />
                    <Message msg={error?.message} />
                  </>
                )}
              />
            </Grid>

            <Message msg={message} />
          </Grid>
        </form>
      </Paper>
    </div>
  );
};
